/**
 * @class
 * @function FreeShipping
 */

if (!customElements.get('free-shipping')) {
  class FreeShipping extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      // 初次解析页面时子节点和延迟脚本可能尚未就绪；购物车局部替换后则在本轮 DOM 更新结束时计算。
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => {
          if (this.isConnected) this.renderProgress();
        }, { once: true });
      } else {
        queueMicrotask(() => {
          if (this.isConnected) this.renderProgress();
        });
      }
    }

    renderProgress() {
      const amountText = this.querySelector('.free-shipping--amount');

      const total = parseInt(this.dataset.cartTotal, 10);

      const rawMinimum = parseInt(this.dataset.minimum, 10);

      const currencyCode =
        this.dataset.currencyCode ||
        window.Shopify?.currency?.active ||
        '';

      const rate = currencyCode === 'USD' ? 1 : Number(window.Shopify?.currency?.rate);

      this.remainingText = this.querySelector(
        '.free-shipping--text-remaining'
      );

      this.fullText = this.querySelector(
        '.free-shipping--text-full'
      );

      // 金额已是当前币种，门槛仍以美元保存；非美元市场拿不到汇率时不展示错误进度。
      if (!Number.isFinite(total) || !Number.isFinite(rawMinimum) || rawMinimum <= 0 ||
          !Number.isFinite(rate) || rate <= 0 || !this.remainingText || !this.fullText) {
        this.hidden = true;
        return;
      }

      // 后台包邮门槛为商店基础货币，
      // 根据当前 Shopify Market 汇率转换为当前货币
      const minimum = Math.round(rawMinimum * rate);

      let percentage = 1;

      if (total < minimum) {
        percentage = total / minimum;

        const remaining = minimum - total;

        if (amountText) {
          // 只格式化数字，不输出 $, €, £ 等符号
          const formattedAmount = typeof formatMoney === 'function'
            ? formatMoney(remaining, '{{amount}}')
            : new Intl.NumberFormat('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(remaining / 100);

          // 例如：1.97 AUD
          amountText.textContent =
            `${formattedAmount} ${currencyCode}`;
        }

        this.remainingText.style.display = 'block';
        this.fullText.style.display = 'none';
      } else {
        this.remainingText.style.display = 'none';
        this.fullText.style.display = 'block';
      }

      this.style.setProperty('--percentage', percentage);
      this.hidden = false;
    }
  }

  customElements.define('free-shipping', FreeShipping);
}
